import { render, staticRenderFns } from "./FailureBid.vue?vue&type=template&id=611f5b2b&scoped=true&"
import script from "./FailureBid.vue?vue&type=script&lang=js&"
export * from "./FailureBid.vue?vue&type=script&lang=js&"
import style0 from "./FailureBid.vue?vue&type=style&index=0&id=611f5b2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611f5b2b",
  null
  
)

export default component.exports